export const NEW_POINT_ID = 'NEW_POINT';
